import { get_logged_data } from "../../../service/Configuration";
const baseUrl = process.env.REACT_APP_BACKEND_URL;
const home_get = (endpoint, data = {}) => {
  return fetch(`${baseUrl}${endpoint}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const home_post = (endpoint, data) => {
  return fetch(`${baseUrl}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
};

const app_auth_post = (endpoint, data) => {
  const token = get_logged_data();
  return fetch(`${baseUrl}/api/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
};

const app_auth_post1 = async (endpoint, payload) => {
  const token = get_logged_data();
  if (!token) throw new Error("Unauthorized: No token found");
  try {
    const response = await fetch(`${baseUrl}/api/${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || `Request failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};


const app_auth_post_out = (endpoint, data) => {
  const token = get_logged_data();
  return fetch(`${baseUrl}/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
};

const app_auth_delete = (endpoint, data) => {
  const token = get_logged_data();
  return fetch(`${baseUrl}/api/${endpoint}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
};

export { home_get, home_post, app_auth_post, app_auth_post_out, app_auth_delete };
